import gql from 'graphql-tag';

const ADD_USER_PCH = gql`
	mutation AddUserPCH($clickId: Int, $pch: AddPCHData) {
		addUserPCH(clickId: $clickId, pch: $pch) {
			success
			status
			message
			body {
				id
			}
		}
	}
`;

export default ADD_USER_PCH;